<template>
    <ListeEcheance/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeEcheance from "@/components/GesCom/Echeance/ListeEcheance.vue";

    export default defineComponent({
      name: "ListeEcheancePage",
      components: {
        
        ListeEcheance,
      },
    });
  </script>